<rid-odd-one-out
  class="h-dvh"
  [questions]="[
    {
      id: '1',
      question: 'Welke zin past er niet bij?',
      options: ['ik heb een kat', 'hij heeft een hond', 'jij hebt een vis', 'zij had een cavia'],
      answer: 2,
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/odd-one-out'])"
/>
